import '../../../../assets/css/request_details.css'
import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import Fab from '@mui/material/Fab';
import swal from 'sweetalert';
import Tooltip from '@mui/material/Tooltip';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";



import { Accordion } from 'react-bootstrap';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Loading_animation_view from '../../../loading_animation_view/loading_animation_view';
import { get_applicant_request_details, service_change_order_state, add_delivery_file_to_orderRequest, check_new_request_for_validation } from '../../../../services/purchase_service';
import { get_order_productsInfos, download_order_file, download_delivery_file, requester_change_order_state, check_weither_ispossible_to_proceed, get_available_currencies } from '../../../../services/for_allServices';
import Order_details_modal from './order_details/order_details';
import Catalogue_modal from './catalogue_modal/catalogue_modal';
import Products_gallery_modal from './products_gallery/products_gallery';
import View_refuse_reason from '../view_refuse_reason/view_refuse_reason';
import Set_refuse_reason from './order_details/set_refuse_reason/set_refuse_reason';
import Stock_details_accordian from './verify_stock/stock_details';
import Validation_history from '../validation_history/validation_history';
import { getActiveProjects } from '../../../../services/project_service';
import { updatePurchaseRequest } from '../../../../services/purchase_service';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: 16,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));




function Request_detail({ title, details }) {

    const [isEditing, setIsEditing] = useState(false);

    const [projects, setProjects] = useState([]);

    const [formDetails, setFormDetails] = useState(details);




    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await getActiveProjects();
                if (response.data.success) {
                    setProjects(response.data.data); // ici "data" est le tableau des projets
                } else {
                    console.error("Erreur : ", response.data.message);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des projets :", error);
            }
        };

        fetchProjects();
    }, []);

     async function save_request_changes() {
            await updatePurchaseRequest(formDetails)
                .then(() => {
                    swal("Succès", "Demande mise à jour avec succès", "success");
                    setIsEditing(false); // désactive la modification
                })
                .catch((error) => {
                    console.error(error);
                    swal("Erreur", "Échec de l'enregistrement", "error");
                });
    
        }

    return (
        <div className="requester_details_container order_plus_details_container">
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className='accordion_header_content'> {title} </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className="order_form_details_container">
                            <div className="order_form_infos_container">
                                <div className='order_form_infos_title'> 1 - Infos personnel</div>
                                <Row className="mb-12">
                                    <Form.Group className="col-6">
                                        <label>Nom</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Nom *"
                                            value={formDetails.requester_lastName}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_lastName: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Prénom</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Prénom *"
                                            value={formDetails.requester_firstName}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_firstName: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Département</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Département *"
                                            value={formDetails.requester_departement}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_departement: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6"> </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Email</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="email"
                                            placeholder="Email *"
                                            value={formDetails.requester_email}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_email: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Numéro de téléphone</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Numéro de téléphone"
                                            value={formDetails.requester_phoneNumber}
                                            onChange={(e) => setFormDetails({ ...formDetails, requester_phoneNumber: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                </Row>
                                <div className='order_form_infos_title'>2 - Infos de livraison</div>
                                <Row className="mb-12">
                                    <Form.Group className="col-6">
                                        <label>Pays</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Pays*"
                                            value={formDetails.delivery_country}
                                            onChange={(e) => setFormDetails({ ...formDetails, delivery_country: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Ville</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Ville *"
                                            value={formDetails.delivery_city}
                                            onChange={(e) => setFormDetails({ ...formDetails, delivery_city: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Adresse</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Adresse *"
                                            value={formDetails.delivery_address}
                                            onChange={(e) => setFormDetails({ ...formDetails, delivery_address: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Code postal</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Code postal *"
                                            value={formDetails.delivery_postCode}
                                            onChange={(e) => setFormDetails({ ...formDetails, delivery_postCode: e.target.value })}
                                            readOnly={true}
                                        />
                                    </Form.Group>

                                    <Form.Group className="col-6">
                                        <label>Date de livraison souhaitée</label>
                                        <Form.Control
                                            type="date"
                                            min={(new Date()).toISOString().split('T')[0]}
                                            placeholder="Date de livraison souhaitée *"
                                            value={formDetails.delivery_supposedDate.split(' ')[0]}
                                            onChange={(e) =>
                                                setFormDetails({
                                                    ...formDetails,
                                                    delivery_supposedDate: e.target.value
                                                })
                                            }
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                </Row>
                                <div className='order_form_infos_title'>3 - Autres informations</div>
                                <Row className="mb-12">
                                    <Form.Group className="col-sm-12">
                                        <label>Projet</label>
                                        {isEditing ? (
                                            // Mode édition : SELECT
                                            <Form.Control
                                                as="select"
                                                value={formDetails.project_code}
                                                onChange={(e) =>
                                                    setFormDetails({
                                                        ...formDetails,
                                                        project_code: e.target.value
                                                    })
                                                }
                                            >
                                                <option value="">Aucun projet (désassocier)</option>
                                                {projects.map((project) => (
                                                    <option key={project.project_code} value={project.project_code}>
                                                        {project.title}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        ) : (
                                            // Mode lecture seule : TEXTE
                                            <Form.Control
                                                type="text"
                                                value={formDetails.project_code}
                                                readOnly
                                            />
                                        )}


                                    </Form.Group>
                                    <Form.Group className="col-sm-12">
                                        <label>Imputation</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            as="textarea" rows="3"
                                            placeholder="Imputation *"
                                            value={formDetails.object}
                                            onChange={(e) =>
                                                setFormDetails({
                                                    ...formDetails,
                                                    object: e.target.value
                                                })
                                            }
                                            readOnly={true}
                                        />
                                    </Form.Group>
                                </Row>
                            </div>
                        </div>
                        <div className="proceed_button_container">
                            {isEditing ? (
                                <Button
                                    className="submit_but valide_but"
                                    onClick={save_request_changes}
                                >
                                    Enregistrer
                                </Button>
                            ) : (
                                <Button
                                    className="submit_but"
                                    onClick={() => setIsEditing(true)}
                                >
                                    Modifier
                                </Button>
                            )}
                        </div>

                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}

function state(request_state) {
    return (
        <>
            {
                request_state === null || request_state === "demander à être changée"
                    ? <Button variant="contained" className="status_waiting">{request_state ? request_state : 'En cours'}</Button>
                    : request_state === "refusée" || request_state === "refus de validation" || request_state === "annulée" || request_state === "non conforme"
                        ? <Button variant="contained" className="status_deny">{request_state}</Button>
                        : request_state === "sous réserve de validation"
                            ? <Button variant="contained" className="status_waiting">{request_state}</Button>
                            : <Button variant="contained" className="status_success">{request_state}</Button>
            }
        </>

    );
}

function request_state(request_state) {
    return (
        <>
            {
                request_state === null || request_state === "demander à être changée" || request_state?.includes("en cours") || request_state === "En cours de livraison (interne)"
                    ? <Button variant="contained" className="status_waiting">{request_state ? request_state : 'En cours'}</Button>
                    : request_state === "annulée" || request_state?.includes("refus") || request_state === "non conforme" || request_state === "Non conforme (interne)"
                        ? <Button variant="contained" className="status_deny">{request_state}</Button>
                        : <Button variant="contained" className="status_success">{request_state}</Button>
            }
        </>

    );
}


function validation_state(validation_state) {
    return (
        <>
            {
                validation_state === 0
                    ? <Button variant="contained" className="status_deny">{"refus de validation"}</Button>
                    : validation_state === null
                        ? <Button variant="contained" className="status_waiting">{"en cours de validation"}</Button>
                        : <Button variant="contained" className="status_success">{"validé"}</Button>
            }
        </>

    );
}


function Order_detail({ title, upload_delivery_file, delivery_filepath, order_number, request_state_tmp, id_supplier, request_code, supplier, details, inner_state,
    products_bysupplier, setProducts_bysupplier, order_key, open_products_gallery_changeSupplier, setRequest_validation_processes, request_validation_processes, able_to_process_request, currencies }) {

    const [chosen_supplier, setChosen_supplier] = useState(null);
    const [open_reason_modal, setOpen_reason_modal] = useState(null);
    const [view_validation_history, setview_validation_history] = useState(null);

    const [request_order_validation, setrequest_order_validation] = useState(null);
    const [able_to_process_order, setable_to_process_order] = useState(null);

    useEffect(() => {
        get_request_order_validation(request_validation_processes, details.order_id);
        verify_request_order_validation(request_validation_processes, details.order_id);
    }, [])

    function download_order_details_file(e, request_code, order_infos) {
        e.stopPropagation();
        let request_code_tmp_array = request_code.split(' - ');
        const formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('order_id', order_infos.order_id);
        download_order_file(formData).then((response) => {
            const blob = new Blob([response.data]);
            const fileURL = window.URL.createObjectURL(blob);
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;

            let file_extension = getFileExtensionFromDisposition(response.headers['content-disposition']);
            fileLink.setAttribute(
                'download',
                `${request_code_tmp_array[0]}_${request_code_tmp_array[1]}_${order_infos.order_id}.${file_extension}`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            window.URL.revokeObjectURL(fileURL); // Clean up
        }).catch((error) => {
            //console.log(error.response);
        });

        // Delivery file
        download_delivery_file(formData).then((response) => {
            const blob = new Blob([response.data]);
            const fileURL = window.URL.createObjectURL(blob);
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;

            let file_extension = getFileExtensionFromDisposition(response.headers['content-disposition']);
            fileLink.setAttribute(
                'download',
                `${request_code_tmp_array[0]}_${request_code_tmp_array[1]}_${order_infos.order_id}_delivery.${file_extension}`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            window.URL.revokeObjectURL(fileURL); // Clean up
        }).catch((error) => {
            //console.log(error.response);
        })
    }

    // Utility to extract file extension from Content-Disposition
    function getFileExtensionFromDisposition(disposition) {
        if (disposition && disposition.includes('filename')) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                return matches[1].replace(/['"]/g, '').split(".").pop();
            }
        }
        return 'pdf'; // default fallback
    }

    function get_request_order_validation(validation_processes, order_id) {
        let order_validation_process = validation_processes.filter((proc) => proc.request_order_id == order_id);
        // ////console.log("get_request_order_validation");
        setrequest_order_validation(order_validation_process);
    }

    function verify_request_order_validation(validation_processes, order_id) {
        let order_validation_process = validation_processes.filter((step) => step.request_order_id == order_id).sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
        let able_to_proceed = true;
        let users_id = [];
        for (let step of order_validation_process) {
            if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
            if (step.validated != 1 && !users_id.includes(step.user)) {
                able_to_proceed = false;
                users_id.push(step.user);
                break;
            }
        }
        //////console.log("validation process : ", order_validation_process, users_id, able_to_proceed);
        setable_to_process_order(able_to_proceed && able_to_process_request);
    }

    async function reverify_request_order_validation(order_id) {
        //console.log(details, order_id);
        const formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('order_id', order_id);
        let validation_processes = await check_weither_ispossible_to_proceed(formData).then((response) => {
            //console.log("check_weither_ispossible_to_proceed : ", response.data);
            let tmp_request_validation = response.data;
            setRequest_validation_processes(tmp_request_validation);
            return response.data;
        }).catch((error) => {
            //console.log(error.response);
        });
        let order_validation_process = validation_processes.filter((step) => step.request_order_id == order_id).sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
        let able_to_proceed = true;
        let users_id = [];
        for (let step of order_validation_process) {
            if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
            if (step.validated != 1 && !users_id.includes(step.user)) {
                able_to_proceed = false;
                users_id.push(step.user);
                break;
            }
        }
        get_request_order_validation(validation_processes, order_id);
        setable_to_process_order(able_to_proceed && able_to_process_request);
        //console.log("validation process : ", order_validation_process, users_id, able_to_proceed);
        return able_to_proceed;
    }


    return (
        <div>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className='order_accordion_header'>
                            <div className='accordion_header_content'>
                                <span>{title}</span>
                                <span className="supplier_infos">
                                    {supplier.substring(0, supplier.lastIndexOf("--")).trim()}
                                    <span onClick={(e) => { e.stopPropagation(); setChosen_supplier(details); }}><CollectionsBookmarkIcon className="my_icon" /></span>
                                    <>
                                        {<span
                                            className='view_reason_button'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setview_validation_history(request_order_validation)
                                            }}
                                        >(Historique)</span>
                                        }
                                    </>
                                </span>
                            </div>
                            <div className='accordion_header_actions'>
                                <>
                                    {
                                        able_to_process_order == true || ["annulée"].includes(details.order_state)
                                            ? <>
                                                {/* <div className='action_button_container' >
                                                    {
                                                        details.order_state !== "annulée" && details.order_state !== "conforme" && (details.order_state !== null && details.order_state !== "demander à être changée") && details.order_state !== "sous réserve de validation"
                                                            ? <>
                                                                {
                                                                    details.order_state !== "bien reçu"
                                                                        ? <Tooltip title="la commande est reçue" placement="top" >
                                                                            <span style={{ color: 'rgb(228, 88, 32)' }}
                                                                                className={details.order_state === "en cours de livraison" ? "my_icon checkIcon" : "my_icon checkIcon disabled_button"}>
                                                                                <DoneIcon style={{ cursor: 'pointer' }} onClick={(e) => well_received(e, id_supplier, request_code, order_key)} />
                                                                            </span>
                                                                        </Tooltip>
                                                                        : <>
                                                                            <Tooltip title="Commande non conforme" placement="top" >
                                                                                <span style={{ color: '#e92a44', marginRight: '4px' }} onClick={(e) => order_no_conforme(e, id_supplier, request_code, order_key)}>
                                                                                    <RemoveDoneIcon style={{ cursor: 'pointer' }} className="my_icon closeSharpIcon" />
                                                                                </span>
                                                                            </Tooltip>
                                                                            <Tooltip title="Commande conforme" placement="top" >
                                                                                <span style={{ color: '#18ac67' }} onClick={(e) => order_conforme(e, id_supplier, request_code, order_key)}>
                                                                                    <DoneAllIcon style={{ cursor: 'pointer' }} className="my_icon checkIcon" />
                                                                                </span>
                                                                            </Tooltip>
                                                                        </>
                                                                }
                                                            </>
                                                            : <></>
                                                    }

                                                </div> */}
                                                <div className='request_state_container'>
                                                    {state(details.order_state)}
                                                    <>
                                                        {["sous réserve de validation", "refusée", "refus de validation", "annulée", "non conforme"].includes(details.order_state) && (
                                                            <span
                                                                className='view_reason_button'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();

                                                                    // Determine the reason to show
                                                                    let reason = details.service_refuse_reason
                                                                        ? details.service_refuse_reason
                                                                        : details.refuse_reason;

                                                                    // If non_conformity_reason exists, use it as well
                                                                    if (inner_state?.non_conformity_reason) {
                                                                        reason = inner_state.non_conformity_reason;
                                                                    }

                                                                    setOpen_reason_modal(reason);
                                                                }}
                                                            >
                                                                Motif
                                                            </span>
                                                        )}
                                                    </>
                                                </div>
                                            </>
                                            : <>{request_order_validation != null ? <View_request_order_validation request_order_validation={request_order_validation} /> : <></>}</>
                                    }
                                </>
                                <span style={{ display: 'flex' }}>
                                    {(!["annulée", "refusée"].includes(details.order_state) && able_to_process_order == true) ? (
                                        details.delivery_file == null ? (
                                            <Tooltip title="Importer le bon de livraison" placement="bottom">
                                                <label htmlFor={'uploadContract' + id_supplier} style={{ marginRight: '8px', cursor: 'pointer' }}>
                                                    <input
                                                        accept="application/*"
                                                        id={'uploadContract' + id_supplier}
                                                        name={'uploadContract' + id_supplier}
                                                        type="file"
                                                        multiple
                                                        style={{ display: 'none' }}
                                                        onChange={(e) => upload_delivery_file(e.target.files[0], details)}
                                                    />
                                                    <Fab size="small" variant="contained" component="span">
                                                        <CloudUploadIcon className="my_icon" />
                                                    </Fab>
                                                </label>
                                            </Tooltip>
                                        ) : null
                                    ) : (
                                        <Tooltip title="Changer le fournisseur" placement="bottom">
                                            <span className={!able_to_process_request ? "disabled_button" : ""} style={{ marginLeft: '8px' }}>
                                                <Fab
                                                    size="small"
                                                    onClick={(e) => open_products_gallery_changeSupplier(e, request_code, details)}
                                                    color="default"
                                                    style={{ backgroundColor: '#29c981', color: 'white' }}
                                                    className={"round_button"}
                                                >
                                                    <PublishedWithChangesIcon className="my_icon" />
                                                </Fab>
                                            </span>
                                        </Tooltip>
                                    )}

                                    <Tooltip title="Exporter en fichier pdf" placement="bottom">
                                        <span style={{ marginLeft: '6px' }}>
                                            <Fab
                                                size="small"
                                                onClick={(e) => download_order_details_file(e, request_code, details)}
                                                color="default"
                                                style={{ backgroundColor: '#efefef' }}
                                                className={
                                                    details.order_file != null ? "round_button"
                                                        : "round_button disabled_button"
                                                }
                                            >
                                                <GetAppRoundedIcon className="my_icon" />
                                            </Fab>
                                        </span>
                                    </Tooltip>
                                </span>

                            </div>
                        </div>

                    </Accordion.Header>
                    <Accordion.Body className={able_to_process_request ? "" : "disabled_button"}>
                        <Order_details_modal selected_order_details={details}
                            request_code={request_code} products_bysupplier={products_bysupplier}
                            id_supplier={id_supplier} setProducts_bysupplier={setProducts_bysupplier}
                            order_key={order_key} order_number={order_number} request_order_validation={request_order_validation}
                            able_to_process_order={able_to_process_order} reverify_request_order_validation={reverify_request_order_validation}
                            currencies={currencies} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            {
                open_reason_modal !== null
                    ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                    : <></>
            }
            {
                chosen_supplier !== null
                    ? <Catalogue_modal setChosen_supplier={setChosen_supplier} chosen_supplier={chosen_supplier} />
                    : <></>
            }
            {
                view_validation_history != null && request_order_validation != null
                    ? <Validation_history view_validation_history={view_validation_history} setview_validation_history={setview_validation_history} />
                    : <></>
            }

        </div>
    )
}


function View_request_order_validation({ request_order_validation }) {
    const [global_validation_state, setglobal_validation_state] = useState(null);
    const [view_validation_history, setview_validation_history] = useState(null);

    useEffect(() => {
        let validated = null;
        let comment = null;
        let tmp_validation_history = request_order_validation.sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
        let users_id = [];
        for (let step of tmp_validation_history) {
            //console.log("step", step);
            if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
            if (step.validated == 0 && !users_id.includes(step.user)) {
                validated = 0;
                comment = step.comment;
                users_id.push(step.user);
                break;
            }
        }
        setglobal_validation_state({
            "validated": validated,
            "comment": comment
        })
    }, [])

    return (
        <>
            {
                global_validation_state != null
                    ? <div className='request_state_container'>
                        {validation_state(global_validation_state.validated)}
                        <>
                            {/*<span
                                    className='view_reason_button'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setview_validation_history(request_order_validation)
                                    }}
                                >
                                    Historique
                                </span>
                            */}
                        </>
                    </div>
                    : <></>
            }
            {
                view_validation_history != null
                    ? <Validation_history view_validation_history={view_validation_history} setview_validation_history={setview_validation_history} />
                    : <></>
            }
        </>
    );
}


function Request_details({ request_code, setRequest_code, request_details, setRequest_details }) {

    const [products_bysupplier, setProducts_bysupplier] = useState(null);
    const [currencies, setCurrencies] = useState([]);
    const [details, setDetails] = useState(null);
    const [inner_state, setInner_state] = useState([]);
    const [delivery_filepath, setDelivery_filepath] = useState(null);
    const [wait_submitting, setWait_submitting] = useState(false);

    const [open_reason_modal, setOpen_reason_modal] = useState(null);

    const [order_count, setOrder_count] = useState(1);
    const [changeSupplier, setChangeSupplier] = useState(null);
    const [changeSupplier_done, setChangeSupplier_done] = useState(null);

    const [request_state_tmp, setrequest_state_tmp] = useState(null);
    const [request_validation_processes, setRequest_validation_processes] = useState([]);
    const [view_validation_history, setview_validation_history] = useState(null);

    const [able_to_process_request, setAble_to_process_request] = useState(false);

    const classes = useStyles();


    async function get_replacement(tmp_products_bysupplier, replaced_by, selected_products_tmp_array) {
        var replaced_by_tmp = replaced_by;
        let replaced_by_array = replaced_by_tmp.split(',');
        var mergedObject = {};
        for (let i in replaced_by_array) {
            if (replaced_by_array[parseInt(i)] !== "") {
                let formData = new FormData();
                formData.append('products_codes', JSON.stringify(selected_products_tmp_array));
                formData.append('request_code', request_code);
                formData.append('replaced_by', parseInt(replaced_by_array[parseInt(i)]));
                mergedObject = await get_order_productsInfos(formData).then((response) => {
                    let data = response.data;
                    for (const id_supplier_name in data) {
                        tmp_products_bysupplier[id_supplier_name] = response.data[id_supplier_name];
                        tmp_products_bysupplier[id_supplier_name]["replaced_by"] = response.data[id_supplier_name].replaced_by ? response.data[id_supplier_name].replaced_by : "";
                        tmp_products_bysupplier[id_supplier_name]["order_id"] = response.data[id_supplier_name].order_id;
                        tmp_products_bysupplier[id_supplier_name]["order_state"] = response.data[id_supplier_name].order_state;
                        tmp_products_bysupplier[id_supplier_name]["service_accord"] = response.data[id_supplier_name].service_accord;
                        tmp_products_bysupplier[id_supplier_name]["products"] = data[id_supplier_name].products;
                        if (response.data[id_supplier_name].replaced_by) get_replacement(tmp_products_bysupplier, replaced_by, selected_products_tmp_array);;
                    }
                    return tmp_products_bysupplier;
                });
            }
        }
        return mergedObject;
    }


     useEffect(()=>{
        get_available_currencies().then((response)=>{
            setCurrencies(response.data);
        }).catch((error)=>{
           //  console.log(error.response);
        })
    },[]);

    useEffect(() => {
        setDetails(null);
        setProducts_bysupplier(null);

        async function get_orders_products(orders, request_code) {
            var tmp_products_bysupplier = {};
            var mergedObject = {};
            for (const id_supplier in ((orders))) {
                let selected_products = orders[id_supplier];
                let selected_products_tmp_array = [];
                selected_products.map((selected_product) => {
                    selected_products_tmp_array.push(selected_product.product_code);
                })
                ////console.log(selected_products_tmp_array);
                //console.log("selected_products_tmp_array******//", products_bysupplier)
                //console.log("selected_products_tmp_array", id_supplier)
                //console.log("selected_products_tmp_array", request_code)
                let formData = new FormData();
                formData.append('products_codes', JSON.stringify(selected_products_tmp_array));
                formData.append('request_code', request_code);
                formData.append('id_supplier', id_supplier);
                ////console.log(request_code,id_supplier);
                var tmp_add_products_bysupplier = {};
                var selected_products_details_tmp_array = [];
                var replaced_by = null;
                mergedObject = await get_order_productsInfos(formData).then(async (response) => {
                    let data = response.data;
                   //  console.log("data",data);
                    for (const id_supplier_name in data) {
                        data[id_supplier_name].products.map((element, id) => {
                            selected_products.map((selected_product, id) => {
                                if (selected_product.product_code === element.product_code) {
                                    element.product_amount = element.product_amount ? element.product_amount : selected_product.product_amount;
                                }
                            })
                            selected_products_details_tmp_array.push(element);
                        });
                        tmp_products_bysupplier[id_supplier_name] = response.data[id_supplier_name];
                        tmp_products_bysupplier[id_supplier_name]["replaced_by"] = response.data[id_supplier_name].replaced_by ? response.data[id_supplier_name].replaced_by : "";
                        tmp_products_bysupplier[id_supplier_name]["order_state"] = response.data[id_supplier_name].order_state;
                        tmp_products_bysupplier[id_supplier_name]["order_id"] = response.data[id_supplier_name].order_id;
                        tmp_products_bysupplier[id_supplier_name]["order_number"] = response.data[id_supplier_name].order_number;
                        tmp_products_bysupplier[id_supplier_name]["service_accord"] = response.data[id_supplier_name].service_accord;
                        tmp_products_bysupplier[id_supplier_name]["products"] = selected_products_details_tmp_array;

                        const replacemment = await get_replacement(tmp_products_bysupplier, tmp_products_bysupplier[id_supplier_name]["replaced_by"], selected_products_tmp_array);
                        if (replacemment && Object.keys(replacemment).length) {
                            mergedObject = {
                                ...mergedObject,
                                ...replacemment
                            };
                        } else {
                            mergedObject = {
                                ...mergedObject,
                                ...tmp_products_bysupplier
                            };
                        }
                        return mergedObject;
                    }

                }).catch((error) => {
                   //  console.log(error.response);
                });

               //  console.log("mergedObject",mergedObject);
            }
            setProducts_bysupplier(mergedObject);
            //console.log("products_bysuppli*$*$*$er", mergedObject);

        }


        async function load_data() {
            const formData = new FormData();
            formData.append('request_code', request_code);
            await check_weither_ispossible_to_proceed(formData).then((response) => {
               //  console.log("check_weither_ispossible_to_proceed s : ", response.data);
                setRequest_validation_processes(response.data);
            }).catch((error) => {
                //console.log(error.response);
            });

            await get_applicant_request_details(formData).then(async (response) => {
                //console.log("get_applicant_request_details",response.data);
                await setrequest_state_tmp(response.data.request_state);
                const tmp_data = {
                    ...request_details,
                    ...response.data
                };
               //  console.log("tmp_data", tmp_data);
                await setAble_to_process_request((!tmp_data.request_state?.includes("refus") && !tmp_data.request_state?.includes("en cours de validation") && !tmp_data.request_state?.includes("annul") && (tmp_data.id_validation == null || tmp_data.validated == 1)));
               //  console.log("able_to_process_request", able_to_process_request);
                await setDetails(tmp_data);
                const suppliers = response.data.selected_suppliers;

                // //console.log("$$$$$$$$$$$$$$$$$$",response.data);
                {
                    suppliers.map((supplier, index) => {
                        let innerState = {};
                        try {
                            innerState = JSON.parse(supplier.inner_state); // Convert string to object
                            setInner_state(innerState);
                            setDelivery_filepath(supplier.delivery_file);
                        } catch (error) {
                            console.error("Error parsing inner_state:", error);
                        }

                        return null; // This ensures the map doesn't break but isn't rendering anything
                    })
                }

                get_orders_products(JSON.parse(response.data.products), request_code);
            }).catch((error) => {
                ////console.log(error.response);
            });
        }


        load_data();

    }, [changeSupplier_done]);


    function get_request_validation_hist(validation_processes) {
        let order_validation_process = validation_processes.filter((proc) => proc.request_order_id == 0);
        return order_validation_process;
    }

    function open_products_gallery_changeSupplier(e, request_code, order_infos) {
        //console.log(order_infos);
        e.stopPropagation();
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('id_supplier', order_infos.id_supplier);
        formData.append('order_id', order_infos.order_id);
        setChangeSupplier(formData);
    }


    function get_order_number(data, id) {
        if (id === 0) {
            return id + 1;
        }
        else {
            if (products_bysupplier[data[id - 1]].replaced_by !== "") {
                return id;
            }
            else {
                let max_id = 1;
                for (let j = 0; j < id; j++) {
                    max_id = Math.max(max_id, get_order_number(data, j));
                }
                return max_id + 1;
            }
        }
    }

    function well_received(e, id_supplier, request_code, key) {
        e.stopPropagation();
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    formData.append('id_supplier', id_supplier);
                    formData.append('request_code', request_code);
                    formData.append('state', "bien reçu");
                    service_change_order_state(formData).then((response) => {
                        ////console.log(response.data);
                        const tmp_order_state = response.data.order_state;
                        let tmp_json = { ...products_bysupplier };
                        tmp_json[key].order_state = tmp_order_state;
                        setProducts_bysupplier(tmp_json);
                        setWait_submitting(false);
                        swal("votre réponse a été enregistrée avec succès et le service sera bientôt notifié !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        ////console.log(error.response);
                        setWait_submitting(false);
                    })
                }
            });
    }


    function order_conforme(e, id_supplier, request_code, key) {
        e.stopPropagation();
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    formData.append('id_supplier', id_supplier);
                    formData.append('request_code', request_code);
                    formData.append('state', "conforme");
                    service_change_order_state(formData).then((response) => {
                        ////console.log(response.data);
                        const tmp_order_state = response.data.order_state;
                        let tmp_json = { ...products_bysupplier };
                        tmp_json[key].order_state = tmp_order_state;
                        setProducts_bysupplier(tmp_json);
                        setWait_submitting(false);
                        swal("votre réponse a été enregistrée avec succès et le fournisseur sera bientôt notifié !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        ////console.log(error.response);
                        setWait_submitting(false);
                    })
                }
            });
    }


    function order_no_conforme(e, id_supplier, request_code, key) {
        e.stopPropagation();
        let formData = new FormData();
        formData.append('id_supplier', id_supplier);
        formData.append('request_code', request_code);
        formData.append('state', "non conforme");
        formData.append('id', key);
        setOpen_reason_modal(formData);
    }

    function refuse_to_treateOrder(request_code) {
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('request_state', "refus de traitement");
        formData.append('state', "refus de traitement");
        setOpen_reason_modal(formData);
    }

    //callback function
    const handleDataLoaded = () => {
        setWait_submitting(false);
    };

    function upload_delivery_file(file, order_infos) {
        setWait_submitting(true);
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('order_id', order_infos.order_id);
        formData.append('delivery_file', file);

        add_delivery_file_to_orderRequest(formData).then((response) => {
            setWait_submitting(false);
            //console.log("**", response.data);
            setDelivery_filepath(response.data.delivery_file_path);

            swal("Fichier de livraison importé avec succès !", {
                icon: "success",
                buttons: true,
            });

        }).catch((error) => {
            setWait_submitting(false);
            swal("Une erreur est survenue lors de l'import du fichier.", {
                icon: "error",
                buttons: true,
            });
        });
    }


    async function send_new_request_for_validation(request_code) {
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then(async (willDelete) => {
                if (willDelete) {
                    setWait_submitting(true);
                    let formData = new FormData();
                    formData.append("request_code", request_code);
                    await check_new_request_for_validation(formData).then((response) => {
                        //console.log(response.data);
                        let tmp_details = { ...details };
                        tmp_details.request_state = "en cours de validation";
                        setDetails(tmp_details);
                        swal("Votre réponse a été enregistrée avec succès !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        //console.log(error.response);
                        swal("Personne n'est prévu pour la validation !", {
                            icon: "warning",
                        });
                    })
                    setWait_submitting(false);
                }
            })
    }


    return (
        <Dialog disableEnforceFocus fullScreen open={request_code ? true : false} onClose={() => { setRequest_code(null); setRequest_details(null) }} className="my_full_dialog contract_full_dialog">
            <AppBar className={classes.appBar}  >
                <Toolbar style={{ backgroundColor: '#343a40' }} >
                    <div className='page_title'>
                        <IconButton edge="start" color="inherit" onClick={() => { setRequest_code(null); setRequest_details(null) }} aria-label="close" >
                            <CloseIcon className="my_icon" />
                        </IconButton>
                        <span> Details  de demande : {request_code} </span>
                        {details !== null
                            ? <><div className='request_state_container'>
                                <>{request_state(details.request_state)}</>
                                {
                                    details.request_state === "demander à être changée" || details.request_state === "refusée"
                                        || details.request_state === "annulée" || details.request_state?.includes("refus")
                                        ? <span className='view_reason_button' onClick={() => setOpen_reason_modal(details.service_refuse_reason
                                            ? details.service_refuse_reason
                                            : details.requester_refuse_reason ?? details.comment)}>
                                            Motif
                                        </span>
                                        : <></>
                                }
                            </div>
                                <>
                                    {<span
                                        className='view_reason_button' style={{ margin: "0", marginLeft: "8px" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setview_validation_history(get_request_validation_hist(request_validation_processes))
                                        }}
                                    >(Historique)</span>
                                    }
                                </>
                            </>
                            : <></>
                        }
                    </div>
                    {
                        details !== null && (details.request_state === null || details.request_state?.includes("refus") || details.request_state?.includes("en cours de validation"))
                            ? <div className="request_order_toolbar_right">
                                <>{
                                    <Tooltip title="Refuser de la traiter" placement="bottom" >
                                        <span>
                                            <Button className={!wait_submitting ? "submit_but notify_requester_button cancel_but" : "submit_but notify_requester_button cancel_but disabled_button"}
                                                onClick={() => refuse_to_treateOrder(request_code)}>
                                                Refuser
                                            </Button>
                                        </span>
                                    </Tooltip>
                                }</>
                                <>{
                                    (details.validated != 1 && (details.request_state === null && details.validated != 1) || (details.request_state?.includes("refus") && !able_to_process_request)) ? <Tooltip title="Envoyer pour la validation" placement="bottom" >
                                        <span>
                                            <Button className={!wait_submitting ? "submit_but notify_requester_button" : "submit_but notify_requester_button disabled_button"}
                                                onClick={() => send_new_request_for_validation(request_code)}>
                                                Envoyer pour la validation
                                            </Button>
                                        </span>
                                    </Tooltip> : <></>
                                }</>
                                <>{/*
                                    !able_to_process_request ? <Tooltip title="Accepter de la traiter" placement="bottom" >
                                        <span>
                                            <Button className={!wait_submitting ? "submit_but notify_requester_button valide_but" : "submit_but notify_requester_button valide_but disabled_button"}
                                                onClick={() => accept_to_treateOrder(request_code)}>
                                                Accepter
                                            </Button>
                                        </span>
                                    </Tooltip>
                                        : <></>
                                */}</>
                            </div>
                            : <></>
                    }
                </Toolbar>
            </AppBar>

            {
                details !== null && products_bysupplier !== null
                    ? <div className="request_details_container">
                        <Request_detail
                            title="Détails"
                            details={details} />

                        <>
                            {
                                Object.keys(products_bysupplier).length !== 0
                                    ? <>
                                        <Stock_details_accordian request_orders={products_bysupplier}
                                            onDataLoaded={handleDataLoaded}
                                            request_code={request_code}
                                            setWait_submitting={setWait_submitting}
                                            request_details={details} able_to_process_request={able_to_process_request} />
                                        {

                                            Object.keys(products_bysupplier).map((key, id) => (
                                                <Order_detail
                                                    key={key}
                                                    title={"Commande " + (get_order_number(Object.keys(products_bysupplier), id)) + " / "}
                                                    order_number={get_order_number(Object.keys(products_bysupplier), id)}
                                                    id_supplier={key.split("*")[0]}
                                                    supplier={key.split("*")[1]}
                                                    request_code={request_code} upload_delivery_file={upload_delivery_file}
                                                    request_state_tmp={request_state_tmp}
                                                    details={products_bysupplier[key]} products_bysupplier={products_bysupplier}
                                                    setRequest_validation_processes={setRequest_validation_processes}
                                                    request_validation_processes={request_validation_processes}
                                                    able_to_process_request={able_to_process_request}
                                                    setProducts_bysupplier={setProducts_bysupplier}
                                                    inner_state={inner_state} delivery_filepath={delivery_filepath}
                                                    order_key={key} open_products_gallery_changeSupplier={open_products_gallery_changeSupplier}
                                                    well_received={well_received} order_conforme={order_conforme} order_no_conforme={order_no_conforme} 
                                                    currencies={currencies}/>
                                            ))
                                        }
                                    </>
                                    : <></>
                            }
                        </>
                    </div>
                    : <Loading_animation_view />
            }


            {
                changeSupplier !== null
                    ? <Products_gallery_modal changeSupplier={changeSupplier} setChangeSupplier={setChangeSupplier} setChangeSupplier_done={setChangeSupplier_done} />
                    : <></>
            }
            {
                open_reason_modal !== null && (open_reason_modal instanceof FormData)
                    ? <Set_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal}
                        details={details} setDetails={setDetails} products_bysupplier={products_bysupplier} setProducts_bysupplier={setProducts_bysupplier} />
                    : <></>
            }

            {
                open_reason_modal !== null && !(open_reason_modal instanceof FormData)
                    ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                    : <></>
            }

            {
                view_validation_history != null
                    ? <Validation_history view_validation_history={view_validation_history} setview_validation_history={setview_validation_history} request_history={request_code} />
                    : <></>
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={wait_submitting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </Dialog>
    )
}

export default Request_details;
